import { configurationContextDefaultValues, useConfiguration } from '@ori/favorites-context';
import { getToken } from '@ori/favorites-utils';
import { useSWR } from '@ori/fetching';
import { useCallback, useMemo } from 'react';

export const useToken = () => {
  const { customerId, identityUrl, tenant } = useConfiguration();
  const fetcher = useCallback(
    async () =>
      getToken({
        identityUrl,
        tenant,
        customerId,
      }),
    [customerId, identityUrl, tenant],
  );
  const { data } = useSWR('token', fetcher);

  return useMemo(
    () => ({
      customerId: data?.getClaim('customer_id') ?? configurationContextDefaultValues.customerId,
      token: data?.toString(),
    }),
    [data],
  );
};
